export default {
  getShowModalStatus: state => state.showModal,
  getOrgShowModalStatus: state => state.showOrgModal,
  getShowModalDraftStatus: state => state.showModalDraft,
  getShowModalReplyStatus: state => state.showModalReply,
  getModalData: state => state.modalData,
  getReplyPostData: state => state.replyPostData,
  getQuotePostData: state => state.quotePostData,
  getShowModalAboutUs: state => state.showModalAboutUs,
  getModalOrgData: state => state.modalOrgData,
};
